// src/pages/user_role_events/UserRoleEventForm.js
import {
  Box,
  Button,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import userRoleEventService from '../../services/userRoleEventService';
import eventService from '../../services/eventService';
import userService from '../../services/userService';
import roleService from '../../services/roleService';
import { isEmpty, map } from 'lodash';

const UserRoleEventForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [initialValues, setInitialValues] = useState({
    user_id: '',
    email: '',
    event_id: '',
    role_id: '',
    entity_id: localStorage?.getItem('entity_id'),
  });

  useEffect(() => {
    const fetchUserRoleEvent = async () => {
      if (id) {
        const response = await userRoleEventService.getUserRoleEvent(id);
        setInitialValues(response.data);
      }
    };
    fetchUserRoleEvent();
  }, [id]);

  const fetchEvents = async () => {
    const response = await eventService.getEvents();
    setEvents(response.data);
  };

  const fetchUsers = async () => {
    const response = await userService.getUsers();
    setUsers(response.data);
  };

  const fetchRoles = async () => {
    const response = await roleService.getRoles();
    setRoles(response.data);
  };

  useEffect(() => {
    fetchRoles();
    fetchUsers();
    fetchEvents();
  }, []);

  const validationSchema = Yup.object().shape({
    user_id: Yup.string().required('User ID is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    event_id: Yup.string().required('Event ID is required'),
    role_id: Yup.string().required('Role ID is required'),
    entity_id: Yup.string().required('Entity ID is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (id) {
        await userRoleEventService.updateUserRoleEvent(id, values);
      } else {
        await userRoleEventService.createUserRoleEvent(values);
      }
      navigate('/user-role-events');
    } catch (error) {
      console.error(error); // Handle error appropriately
    } finally {
      setSubmitting(false);
    }
  };

  const labelStyle = {
    color: '#000',
    fontSize: '0.87rem',
    marginTop: 8,
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'Edit User Role Event' : 'Add User Role Event'}
        backTo='/user-role-events'
      />
      <div className='page-content-wrapper scrollable'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form onSubmit={handleSubmit}>
              {/* <TextField
                placeholder='User ID'
                name='user_id'
                fullWidth
                value={values.user_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.user_id && Boolean(errors.user_id)}
                helperText={touched.user_id && errors.user_id}
              /> */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>User</div>
                <Select
                  name='user_id'
                  value={values.user_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(users) ? (
                    map(users, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.user_id && errors.user_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.user_id}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Email</div>
                <TextField
                  name='email'
                  fullWidth
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.email && errors.email && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.email}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Event</div>
                <Select
                  name='event_id'
                  value={values.event_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(events) ? (
                    map(events, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.event_id && errors.event_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.event_id}
                  </FormHelperText>
                )}
              </Box>
              {/* <TextField
                placeholder='Role ID'
                name='role_id'
                fullWidth
                margin='normal'
                value={values.role_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.role_id && Boolean(errors.role_id)}
                helperText={touched.role_id && errors.role_id}
              /> */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Role</div>
                <Select
                  name='role_id'
                  value={values.role_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(roles) ? (
                    map(roles, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.role_id && errors.role_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.role_id}
                  </FormHelperText>
                )}
              </Box>
              {/* <TextField
                placeholder='Entity ID'
                name='entity_id'
                fullWidth
                margin='normal'
                value={values.entity_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.entity_id && Boolean(errors.entity_id)}
                helperText={touched.entity_id && errors.entity_id}
              /> */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                <Button
                  type='submit'
                  variant='contained'
                  sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                >
                  {id ? 'Update' : 'Create'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </LayoutContainer>
  );
};

export default UserRoleEventForm;
